import * as THREE from 'three';
import { TrackElement } from './TrackElement';
import { TrainingTrackElement } from '../../../../../shared/src/trainingTrack.types';
import { TRAINING_TRACK_CONFIG } from '../config/TrainingTrackConfig';

/**
 * Class representing a track marker element in the training track
 */
export class TrackMarkerElement extends TrackElement {
    private markerMesh: THREE.Mesh | null = null;
    
    /**
     * Constructor
     * @param element The track marker element data
     */
    constructor(element: TrainingTrackElement) {
        super(element);
    }
    
    /**
     * Creates the Three.js object for this track marker
     * @returns The created track marker object
     */
    protected createObject(): THREE.Object3D {
        // Create a flat rectangle for the track marker
        const geometry = new THREE.PlaneGeometry(
            TRAINING_TRACK_CONFIG.TRACK_MARKER.WIDTH * this.element.scale,
            TRAINING_TRACK_CONFIG.TRACK_MARKER.HEIGHT
        );
        const material = new THREE.MeshBasicMaterial({
            color: TRAINING_TRACK_CONFIG.TRACK_MARKER.COLOR,
            transparent: true,
            opacity: TRAINING_TRACK_CONFIG.TRACK_MARKER.OPACITY,
            side: THREE.DoubleSide
        });
        
        this.markerMesh = new THREE.Mesh(geometry, material);
        this.markerMesh.rotation.x = -Math.PI / 2; // Lay flat on the ground
        this.markerMesh.position.y = 0.05; // Slightly above ground to prevent z-fighting
        
        return this.markerMesh;
    }
    
    /**
     * Handles player interaction with this track marker
     * @param playerPosition The player's position
     * @param playerTank The player's tank
     * @param distance The distance to the player
     * @returns True if interaction was handled, false otherwise
     */
    public handleInteraction(playerPosition: THREE.Vector3, playerTank: any, distance: number): boolean {
        // Track markers don't have special interactions
        return false;
    }
}